import { VF_INPUT } from 'AppSrc/core/components/forms/form-base-components/v-f-input';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';

const fieldId = 'incident';

const initialValues = '';

const vFParams = {
  fieldTitle: 'Incident',
  characterLimit: 15, // don't forget to add to validator
  placeholder: 'Enter text',
};

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;


  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_INPUT);
  const overCharacterLimit = commonValidation.textInput.isOverCharacterLimit(values[fieldId], vFParams.characterLimit);
  // const hasSpecialCharacter = commonValidation.textInput.hasSpecialCharacter(values[fieldId]);
  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((overCharacterLimit) ? 'Text exceeds character limit' : null);
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please enter incident' : null);
  // errors[INLINE_ERRORS].push((hasSpecialCharacter) ? 'Special character < cannot be accepted in Ace' : null);
  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const incident = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_INPUT,
};

export { incident };
